import { render, staticRenderFns } from "./TableAssessments.vue?vue&type=template&id=17b27713&"
import script from "./TableAssessments.vue?vue&type=script&lang=ts&"
export * from "./TableAssessments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports